import 'react-native-gesture-handler';
import {StatusBar} from 'expo-status-bar';
import React, {useState} from 'react';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {useFonts, Inter_900Black} from '@expo-google-fonts/inter';

import useCachedResources from './hooks/useCachedResources';
import useColorScheme from './hooks/useColorScheme';
import Navigation from './navigation';
import {AppLoading} from 'expo';
import AppContext from './components/AppContext';

export default function App() {
  // Setters for the AppContect variables.
  const [startAddress, setStartAddress] = useState<string | null>(null);
  const [startLat, setStartLat] = useState<number | null>(null);
  const [startLon, setStartLon] = useState<number | null>(null);
  const [destinationAddress, setDestinationAddress] = useState<string | null>(null);
  const [destinationLat, setDestinationLat] = useState<number | null>(null);
  const [destinationLon, setDestinationLon] = useState<number | null>(null);

  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  let [fontsLoaded] = useFonts({
    Inter_900Black,
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  }

  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <AppContext.Provider value={{}}>
        <SafeAreaProvider>
          <Navigation colorScheme={colorScheme} />
          <StatusBar />
        </SafeAreaProvider>
      </AppContext.Provider>
    );
  }
}
